import { FSLocale, getIsoCodeFromLocale } from '../languages';

type formatPriceArgs = {
	currencyCode?: string;
	value?: string | number;
	locale?: string;
	useGrouping?: boolean;
	decimalPlaces?: number;
	removeCurrency?: boolean;
};

export default function formatPrice({
	currencyCode = 'USD',
	value: initialValue,
	locale = 'en',
	useGrouping = true,
	decimalPlaces = 2,
	removeCurrency = false,
}: formatPriceArgs = {}): string {
	function innerFormatPrice(value: string | number) {
		//Check the format of the value provided - number preferred, but will accept and parse a string
		let price;
		if (typeof value === 'string') {
			price = Number.parseFloat(value);
		} else if (typeof value === 'number') {
			price = value;
		} else {
			throw Error('Value is unsupported type');
		}

		// Returned if no currency is found rather than a default currency as will show incorrect price
		// with another currency. A blank/whitespace code is treated the same way - it's not a valid
		// ISO 4217 code and `Intl.NumberFormat` would throw a RangeError on it.
		if (currencyCode === 'N/A' || currencyCode.trim() === '') {
			return '-';
		}

		try {
			const formattedCurrency = Intl.NumberFormat(getIsoCodeFromLocale(locale as FSLocale), {
				style: 'currency',
				currencyDisplay: 'code',
				currency: currencyCode,
				useGrouping,
				minimumFractionDigits: decimalPlaces,
				maximumFractionDigits: decimalPlaces,
			}).format(price);

			return removeCurrency ? formattedCurrency.replace(/[^0123456789.,]/g, '') : formattedCurrency;
		} catch (e) {
			console.error(e);
			return '-';
		}
	}

	return initialValue !== undefined ? innerFormatPrice(initialValue) : '';
}
